import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import IncidentReportForm from "./IncidentReportComponents/IncidentReportForm";

import {
  useGetIncidentReportDetailQuery,
  useUpdateIncidentReportMutation,
} from "store/services/incidentReportApi";

import { useAppMeta } from "hooks";

const IncidentReportEditScreen = () => {
  const { id } = useParams(); // Get Collection ID from the URL parameters
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Incident Reports", path: "/app/crm/incident-report/list" },
    { title: "Edit Reports" },
  ];

  // RTK Query
  const {
    data: incidentReportDetail,
    isLoading: loadingIncidentReport,
    error,
  } = useGetIncidentReportDetailQuery(id); // Fetch collection Details using the ID

  const [updateIncidentReport, { isLoading: updatingIncidentReport }] =
  useUpdateIncidentReportMutation(); // Mutation to update collection Details

  // Update handler
  const handleIncidentReport = async (data) => {
    const payload = { id, ...data };

    try {
      await updateIncidentReport(payload).unwrap();
      toast.success("Incident Report successfully updated!");
      navigate(`/app/crm/incident-report/${id}/detail`); // Redirect to collection Detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update incident report!"
      );
    }
  };

  useAppMeta("Edit Incident Report");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingIncidentReport || updatingIncidentReport}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <IncidentReportForm
          isBusy={loadingIncidentReport || updatingIncidentReport}
          incidentReportDetail={incidentReportDetail} // Pass the fetched collection Details to the form
          onSubmit={handleIncidentReport}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default IncidentReportEditScreen;
